import { useState } from 'react';
import { Text, Box, Stack, Icons, styled, Menu, MenuItem } from '@/theme/index';

export const StyledActionText = styled(Text)(({ theme }) => ({
  fontSize: '14px',
  marginLeft: theme.spacing(0.5),

  ':hover': {
    cursor: 'pointer',
  },
}));

const SummaryActionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  marginRight: theme.spacing(2),

  ':hover': {
    cursor: 'pointer',
  },

  ':last-child': {
    marginRight: 0,
  },
}));

interface PropertySummaryActionsProps {
  summaryText: string;
  regenerateSummary: (tone?: string) => void;
  enqueueSnackbar: (message: string, options: object) => void;
  trackEvent: (category: string, action: string, label?: string) => void;
}

export const PropertySummaryActions = (
  actionsValues: PropertySummaryActionsProps
) => {
  const [openSelect, setOpenSelect] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const { summaryText, regenerateSummary, enqueueSnackbar, trackEvent } =
    actionsValues;
  const tones = [
    { display: 'Home Buyer', value: 'Home Buyer' },
    { display: 'Long Term Renter', value: 'Long Term Renter' },
    { display: 'Short Term Renter', value: 'Short Term Renter' },
  ];

  const copyToClipboard = () => {
    trackEvent('copy', 'click', 'property summaries');
    enqueueSnackbar('Copied to clipboard', {
      variant: 'success',
      autoHideDuration: 3000,
    });
    navigator.clipboard.writeText(summaryText);
  };

  const regenerate = () => {
    trackEvent('regenerate', 'click', 'property summaries');
    regenerateSummary();
  };

  const changeSummaryTone = (tone: string) => {
    trackEvent('change tone', 'click', 'property summaries');
    regenerateSummary(tone);
  };

  return (
    <Stack direction="column" alignItems="center" mt={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        data-cy="summary_text"
      >
        <SummaryActionWrapper onClick={copyToClipboard}>
          <Icons.ContentCopy sx={{ height: '18px', width: '18px' }} />
          <StyledActionText>Copy</StyledActionText>
        </SummaryActionWrapper>
        <SummaryActionWrapper onClick={regenerate}>
          <Icons.Replay5 sx={{ height: '18px', width: '18px' }} />
          <StyledActionText>Regenerate</StyledActionText>
        </SummaryActionWrapper>
        <SummaryActionWrapper
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
            setOpenSelect(!openSelect);
          }}
        >
          <Icons.AssistantOutlined sx={{ height: '18px', width: '18px' }} />
          <StyledActionText>Listing Pro AI</StyledActionText>
          <Menu
            open={openSelect}
            anchorEl={anchorEl}
            className="property-summary-tones-menu"
            sx={{
              marginTop: '10px',
            }}
          >
            {tones.map((item, index) => (
              <MenuItem
                sx={{ minWidth: '185px' }}
                key={`${item.display}-${index}`}
                onClick={() => changeSummaryTone(item.value)}
              >
                <Text>{item.display}</Text>
              </MenuItem>
            ))}
          </Menu>
        </SummaryActionWrapper>
      </Box>
    </Stack>
  );
};
